<script setup lang="ts">
import { getSeoObject } from "~/helpers/seo";

const { data } = useCustomFetch("/api/strapi/regulation-center");

// useSeoMeta(getSeoObject(data.value?.seo));
</script>

<template>
  <section v-if="data" id="maincontentblock" class="regulationblock">
    <SeoMeta v-if="data?.seo" v-bind="data?.seo" />
    <div class="container">
      <div
        class="blureffect maingloweff aos-init aos-animate"
        data-aos="fade-down"
        data-aos-easing="linear"
        data-aos-duration="1500"
      ></div>
      <div class="regtypes">
        <div class="row">
          <div class="col-md-12">
            <h2 class="title regulation-title">{{ data.title }}</h2>
            <p
              class="titledesci"
              v-html="$mdRenderer.renderInline(data.description)"
            ></p>
          </div>
        </div>
      </div>

      <div class="glassglowreg">
        <div class="row">
          <div class="col-md-12">
            <h2>{{ data.documentsTitle }}</h2>
            <p style="white-space: pre-line">
              {{ data.documentsDescription }}
            </p>
          </div>
        </div>

        <div class="row">
          <div class="col-xs-12 col-lg-6">
            <template
              v-for="(item, index) in data.documentsItems"
              :key="item.id"
            >
              <div v-if="index < 4" class="linkglow">
                <NuxtLink
                  :to="item.url"
                  :target="item.openInNewTab ? '_blank' : '_self'"
                >
                  {{ item.name }}
                </NuxtLink>
              </div>
            </template>
          </div>

          <div class="col-xs-12 col-lg-6">
            <template
              v-for="(item, index) in data.documentsItems"
              :key="item.id"
            >
              <div v-if="index > 3" class="linkglow">
                <NuxtLink
                  :to="item.url"
                  :target="item.openInNewTab ? '_blank' : '_self'"
                >
                  {{ item.name }}
                </NuxtLink>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </section>

  <JoinCta />

  <FaqItems :items="data?.faqs" />
</template>
